<template>
  <div class="usage">
    <div class="label">
      {{ label }}
    </div>
    <div class="line" />
    <div class="value">
      <slot name="extra-info" />
      <slot>{{ value }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UsageRow',
  props: {
    label: {
      type: String,
      default: 'Reports left'
    },
    value: {
      type: String,
      default: '5 / 5'
    }
  }
}
</script>

<style scoped>
.usage {
  height: 24px;
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.label {
  font-size: 14px;
  font-weight: 500;
  color: rgba(9, 21, 64, 0.68);
  white-space: nowrap;
  text-transform: capitalize;
}

.line {
  flex: 1;
  border-bottom: 1px dotted rgba(9, 21, 64, 0.24);
}

.value {
  font-size: 14px;
  font-weight: 600;
  color: #091540;
  white-space: nowrap;
  display: flex;
  align-items: flex-end;
  gap: 4px;
}
</style>
